const defaultBlendMode = "overlay"; // used in IE...

_.each(
    document.getElementsByClassName( 'blend' ),
    function( element ) {
        let style               = window.getComputedStyle( element ),
            backgroundColor     = style.getPropertyValue( 'background-color' ),
            backgroundImage     = style.getPropertyValue( 'background-image' )
                .replace(/^url\(|\)$/g, '')
                .replace(/^"|"$/g, ''),
            backgroundBlendMode = style.getPropertyValue( 'background-blend-mode' )
                ? style.getPropertyValue( 'background-blend-mode' )
                : defaultBlendMode;

        if ( ! element.getAttribute( 'data-blend' ) ) {
            element.setAttribute( 'data-blend', backgroundBlendMode );
        }
        element.setAttribute( 'data-blend-image', backgroundImage );
        element.setAttribute( 'data-blend-color', backgroundColor );
    }
);

/*
 *  JavaScript Background Blend Mode - v0.1
 *  A JavaScript based polyfill for browsers that don’t support CSS background-blend-mode
 *
 *  https://github.com/juanbrujo/js-background-blend-mode
 *
 *  By: Jorge Epuñan |  @csslab
 *  License: MIT
 */
!function(a){if(function(b){return void 0!==a[b]||("undefined"!=typeof console&&console.log("Warning: canvas context not supported ("+b+" needed)"),!1)}("HTMLCanvasElement")){document.addEventListener("DOMContentLoaded",function(){void 0===a.getComputedStyle(document.body).backgroundBlendMode&&b()},!1);var b=function(){for(var a=document.querySelectorAll("[data-blend]"),b=0;b<a.length;b++){var d=a[b],e=d.getAttribute("data-blend"),f=d.getAttribute("data-blend-image"),g=d.getAttribute("data-blend-color");c(d,e,f,g)}},c=function(a,b,c,e){d(c,e,b,function(b){a.style.backgroundImage="url("+b+")"})},d=function(a,b,c,d){var e=document.createElement("img");e.src=a,e.onload=function(){var a=document.createElement("canvas");a.width=this.naturalWidth,a.height=this.naturalHeight;var e=a.getContext("2d");e.globalCompositeOperation=c,e.drawImage(this,0,0),e.fillStyle=b,e.fillRect(0,0,a.width,a.height);var f=a.toDataURL("image/jpeg");d(f)}}}}(window);
